var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('VueSignaturePad',{ref:"signaturePad",attrs:{"width":"400px","height":"200px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }